import webBackApi from '../../api/webBackApi';

const API_PATH = "/api/sales-codes";

export const createSalesCode = async (salesCodeData) => {
  try {
    const response = await webBackApi.post(API_PATH, salesCodeData);
    return response.data;
  } catch (error) {
    console.error("Error creating sales code:", error);
    throw error;
  }
};

export const getAllSalesCodes = async () => {
  try {
    const response = await webBackApi.get(API_PATH);
    return response.data;
  } catch (error) {
    console.error("Error fetching sales codes:", error);
    throw error;
  }
};

export const validateSalesCode = async (codigo) => {
  try {
    const response = await webBackApi.post(`${API_PATH}/validate`, { codigo });
    return response.data;
  } catch (error) {
    console.error("Error validating sales code:", error);
    throw error;
  }
};
